import {
  GROUP_REPORT,
  GROUP_REPORT_SUCCESSFUL,
  GROUP_REPORT_FAILED,
  GROUP_FETCH,
  GROUP_FETCH_SUCCESSFUL,
  GROUP_FETCH_FAILED
} from "./actionTypes"

export const groupReport = (groupReport, history) => {
  return {
    type: GROUP_REPORT,
    payload: { groupReport, history },
  }
}

export const groupReportSuccessful = groupReport => {
  return {
    type: GROUP_REPORT_SUCCESSFUL,
    payload: groupReport,
  }
}

export const groupReportFailed = error => {
  return {
    type: GROUP_REPORT_FAILED,
    payload: error,
  }
}


export const groupFetchReport = (token) => {
  return {
    type: GROUP_FETCH,
    payload: { token },
  }
}

export const groupFetchSuccessful = group => {
  return {
    type: GROUP_FETCH_SUCCESSFUL,
    payload: group,
  }
}

export const groupFetchFailed = error => {
  return {
    type: GROUP_FETCH_FAILED,
    payload: error,
  }
}
